import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-multi-select-confirm-dismiss',
  templateUrl: './multi-select-confirm-dismiss.component.html',
  styleUrls: ['./multi-select-confirm-dismiss.component.scss'],
})
export class MultiSelectConfirmDismissComponent {

  @Input() numShiftsSelected: number;
  @Output() confirmDismissEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalCtrl: ModalController) { }

  getShiftsSelectedMessaging() {
    return `You’ve selected ${this.numShiftsSelected} shift${this.numShiftsSelected > 1 ? 's' : ''}`;
  }

  async closeModal() {
    await this.modalCtrl.dismiss();
  }

  async returnToJob() {
    await this.modalCtrl.dismiss();
    this.confirmDismissEvent.emit();
  }
  
}
